module.exports = __webpack_public_path__ + "static/img/暂无订单.73ad55e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/暂无订单.jpg
// module id = QuLR
// module chunks = 1